import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { ReactComponent as ArrowIcon } from 'assets/svgs/arrow.svg';
import React, { FC, memo } from 'react';

interface Props {
  className?: string;
  onClick?: () => void;
  next?: boolean;
}

const ArrowWrapper = styled(Box)<{ next?: boolean }>`
  display: block;
  z-index: 2;
  margin-left: 8px;
  cursor: pointer;
  svg {
    transform: ${(props): string => (props.next ? 'rotate(180deg)' : '')};
    width: 12px;
    height: 10px;
  }
`;

const Arrow: FC<Props> = ({ className, onClick, next }) => (
  <ArrowWrapper className={className} onClick={onClick} next={next} sx={{ '& svg path': { stroke: 'other.sliderGray' } }}>
    <ArrowIcon />
  </ArrowWrapper>
);

export default memo(Arrow);
